(function () {
  const SOCIAL_TYPE = "social-reels";
  const MAP_TYPE = "heritage-map";

  function sectionNodes(scope, type) {
    const root = scope || document;
    return Array.from(root.querySelectorAll('[data-section-type="' + type + '"]'));
  }

  function destroyCarousel(node) {
    if (node._reelsCarousel && typeof node._reelsCarousel.destroy === "function") {
      node._reelsCarousel.destroy();
    }
    node._reelsCarousel = null;
  }

  function initCarousel(node) {
    if (node._reelsCarousel || !window.flu || !window.flu.chunks || !window.flu.chunks.swiper) return;

    const swiperEl = node.querySelector(".social-reels__content");
    if (!swiperEl) return;

    import(window.flu.chunks.swiper).then(function (mod) {
      const Swiper = mod.Swiper;
      const Navigation = mod.Navigation;
      const nextEl = node.querySelector("[data-next]");
      const prevEl = node.querySelector("[data-prev]");
      const slideCount = swiperEl.querySelectorAll(".social-reels__item").length;

      destroyCarousel(node);
      let gestureStartX = 0;
      let gestureStartY = 0;
      node._reelsCarousel = new Swiper(swiperEl, {
        slidesPerView: "auto",
        spaceBetween: 12,
        grabCursor: slideCount > 1,
        simulateTouch: true,
        touchEventsTarget: "container",
        watchSlidesProgress: true,
        resistanceRatio: 0.65,
        threshold: 8,
        touchAngle: 45,
        touchStartPreventDefault: false,
        touchMoveStopPropagation: false,
        preventClicks: false,
        preventClicksPropagation: false,
        modules: nextEl && prevEl ? [Navigation] : [],
        navigation:
          nextEl && prevEl
            ? {
                nextEl: nextEl,
                prevEl: prevEl,
              }
            : undefined,
        breakpoints: {
          720: {
            spaceBetween: 20,
          },
          960: {
            spaceBetween: 24,
          },
        },
        on: {
          touchStart: function (_swiper, event) {
            const point = event.touches ? event.touches[0] : event;
            gestureStartX = point.clientX;
            gestureStartY = point.clientY;
            this.allowTouchMove = true;
          },
          sliderFirstMove: function (_swiper, event) {
            const point = event.touches ? event.touches[0] : event;
            const dx = Math.abs(point.clientX - gestureStartX);
            const dy = Math.abs(point.clientY - gestureStartY);
            if (dy > dx) {
              this.allowTouchMove = false;
            }
          },
          touchEnd: function () {
            this.allowTouchMove = true;
          },
        },
      });
    });
  }

  window.initSocialReelsSection = initSocialReels;
  window.unloadSocialReelsSection = unloadSocialReels;
  window.initHeritageMapSection = initHeritageMap;
  window.unloadHeritageMapSection = unloadHeritageMap;

  function initSocialReels(node) {
    if (!node || node.dataset.reelsReady === "true") return;
    node.dataset.reelsReady = "true";

    initCarousel(node);
  }

  function unloadSocialReels(node) {
    if (!node) return;
    destroyCarousel(node);
    delete node.dataset.reelsReady;
  }

  function setActivePin(node, index) {
    const pins = node.querySelectorAll("[data-heritage-pin]");
    const notes = node.querySelectorAll("[data-heritage-note]");

    pins.forEach(function (pin) {
      const isActive = pin.getAttribute("data-pin-index") === String(index);
      pin.classList.toggle("is-active", isActive);
      pin.setAttribute("aria-expanded", isActive ? "true" : "false");
    });

    notes.forEach(function (note) {
      const isActive = note.getAttribute("data-pin-index") === String(index);
      note.classList.toggle("is-active", isActive);
      note.hidden = !isActive;
    });
  }

  function initHeritageMap(node) {
    if (!node || node.dataset.mapReady === "true") return;
    node.dataset.mapReady = "true";

    node._mapClickHandler = function (event) {
      const pin = event.target.closest("[data-heritage-pin]");
      if (!pin || !node.contains(pin)) return;
      setActivePin(node, pin.getAttribute("data-pin-index"));
    };

    node.addEventListener("click", node._mapClickHandler);
  }

  function unloadHeritageMap(node) {
    if (!node) return;
    if (node._mapClickHandler) {
      node.removeEventListener("click", node._mapClickHandler);
    }
    delete node.dataset.mapReady;
  }

  function initAll(scope) {
    sectionNodes(scope, SOCIAL_TYPE).forEach(initSocialReels);
    sectionNodes(scope, MAP_TYPE).forEach(initHeritageMap);
  }

  function unloadFrom(event) {
    const target = event.target;
    sectionNodes(target, SOCIAL_TYPE).forEach(unloadSocialReels);
    sectionNodes(target, MAP_TYPE).forEach(unloadHeritageMap);
    if (target.matches && target.matches('[data-section-type="' + SOCIAL_TYPE + '"]')) {
      unloadSocialReels(target);
    }
    if (target.matches && target.matches('[data-section-type="' + MAP_TYPE + '"]')) {
      unloadHeritageMap(target);
    }
  }

  function showHomeSignupEveryLoad() {
    if (!document.body.classList.contains("template-index")) return;

    const popup = document.querySelector('[data-popup][data-show-every-load="true"]');
    if (!popup) return;

    const id = popup.getAttribute("data-id");
    try {
      localStorage.removeItem("fluco_popup-" + id);
      localStorage.removeItem("fluco_signup-dismissed-" + id);
    } catch (err) {
      /* ignore */
    }

    if (localStorage.getItem("fluco_signup-submitted-" + id)) return;

    const openPopup = function () {
      const tabButton = document.querySelector('.popup__tab[data-id="' + id + '"] .popup__tab-button');
      if (tabButton) {
        tabButton.click();
        return;
      }

      popup.classList.add("visible", "animation--popup-revealed");
      document.body.setAttribute("data-fluorescent-overlay-open", "true");
    };

    window.setTimeout(openPopup, 0);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll(document);
      showHomeSignupEveryLoad();
    });
  } else {
    initAll(document);
    showHomeSignupEveryLoad();
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
  document.addEventListener("shopify:section:unload", unloadFrom);
  document.addEventListener("shopify:block:select", function (event) {
    const map = event.target.closest('[data-section-type="' + MAP_TYPE + '"]');
    if (!map) return;
    const pin = event.target.closest("[data-heritage-pin]") || event.target.querySelector("[data-heritage-pin]");
    if (pin) setActivePin(map, pin.getAttribute("data-pin-index"));
  });
})();
